import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import NewCommunicationIcon from "@mui/icons-material/NoteAdd";

import { createNewCommunicationTemplate } from "../../data/omniDataModel";
import * as AdminSessionActions from "../../state/redux/adminSession";
import { deepCopyObject } from "../../utils/helpers";
import AlertDialog from "../dialogs/alertDialog";
import CommunicationTemplateDialog from "../dialogs/communicationTemplateDialog";
import OmniCommunicationTemplateListItem from "../ui/omniCommunicationTemplateListItem";
import OmniResponsiveButton from "../ui/omniResponsiveButton.js";
import Widget from "../ui/widget";
import WidgetList from "../ui/widgetList";
import WidgetSkeleton from "../ui/widgetSkeleton";
import WidgetTitle from "../ui/widgetTitle";

const AdminCommunicationTemplates = props => {
  const { communicationTemplateODMs } = props;

  const [confirmSend, setConfirmSend] = useState(false);
  const [selectedCommunication, setSelectedCommunication] = useState(null);
  const [titleText, setTitleText] = useState(null);

  useEffect(() => {
    if (communicationTemplateODMs != null) {
      setTitleText(
        `${communicationTemplateODMs.length} Template${
          communicationTemplateODMs.length === 1 ? "" : "s"
        } `,
      );
    } else {
      setTitleText("Loading...");
      props.loadCommunicationTemplatesRequest();
    }
    // Disable eslint because AaronK knows best
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [communicationTemplateODMs]);

  return (
    <Widget>
      <WidgetTitle
        title={"Communication"}
        text={titleText}
        loading={communicationTemplateODMs == null}
      >
        <OmniResponsiveButton
          icon={<NewCommunicationIcon />}
          tooltipTitle="Create a new Communication Template"
          buttonText="Define"
          onClick={() => {
            let theRep = createNewCommunicationTemplate();
            setSelectedCommunication(theRep);
          }}
        />
      </WidgetTitle>

      {communicationTemplateODMs == null && <WidgetSkeleton />}
      {communicationTemplateODMs != null && (
        <WidgetList>
          {communicationTemplateODMs.map((commReq, index) => {
            return (
              <OmniCommunicationTemplateListItem
                key={`AdminCommunicationTemplates-${index}`}
                communicationTemplateODM={commReq}
                onClickHandler={() => {
                  setSelectedCommunication(commReq);
                }}
                onSendHandler={() => {
                  setConfirmSend(commReq);
                }}
                onCopyHandler={originalTemplate => {
                  let newTemplate = deepCopyObject(originalTemplate);
                  newTemplate.omniData.name = newTemplate.omniData.name + "_COPY";
                  newTemplate._id = null;
                  newTemplate.omniRelationships.relatedData = [];

                  setSelectedCommunication(newTemplate);
                }}
              />
            );
          })}
        </WidgetList>
      )}

      {selectedCommunication && (
        <CommunicationTemplateDialog
          organizationODM={props.organizationODM}
          open={selectedCommunication != null}
          dialogTitle={`${
            selectedCommunication._id == null
              ? "Create Communication Template"
              : "Communication Template"
          }`}
          communicationTemplateODM={deepCopyObject(selectedCommunication)} //this widget just creates new
          onDelete={id => {
            props.deleteCommunicationTemplateRequest(id);
            setSelectedCommunication(null);
          }}
          onAccept={communicationTemplate => {
            props.updateCommunicationTemplateRequest(communicationTemplate);
            setSelectedCommunication(null);
          }}
          onClose={() => {
            setSelectedCommunication(null);
          }}
          awsUser={props.awsUser}
        />
      )}
      {confirmSend && (
        <AlertDialog
          open={confirmSend}
          dialogTitle={`Confirm`}
          dialogMessage={"Send this Communication Request to our Email Service?"}
          onAccept={() => {
            // onDeleteHandler();
            setConfirmSend(null);
          }}
          onClose={() => {
            setConfirmSend(null);
          }}
        />
      )}
    </Widget>
  );
};
const mapStateToProps = state => ({
  communicationTemplateODMs: state.adminSession.communicationTemplateODMs,
  awsUser: state.userSession.awsUser,
  organizationODM: state.userSession.organizationODM,
});

const mapDispatchToProps = {
  loadCommunicationTemplatesRequest: AdminSessionActions.loadCommunicationTemplatesRequest,
  updateCommunicationTemplateRequest: AdminSessionActions.updateCommunicationTemplateRequest,
  deleteCommunicationTemplateRequest: AdminSessionActions.deleteCommunicationTemplateRequest,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(AdminCommunicationTemplates));
